import {TaskAssignees} from 'shared/models/task/member';

export const prepareAssignees = (members: TaskAssignees[]) =>
  members.map((member) => ({memberId: member.memberId, memberRole: member.memberRole}));
